import updateSetWorkoutExerciseAction from '../update-set'
import { getCurrentSetWorkoutExerciseSelect } from '../../selectors/get-current-set'
import { updateCountKeySetDataUtil } from '../../../model'

function updateSetCountKeyWorkoutExerciseAction (value) {
  return (dispatch, getState) => {
    const set = getCurrentSetWorkoutExerciseSelect(getState())
    dispatch(updateSetWorkoutExerciseAction({
      set: updateCountKeySetDataUtil(set, value),
      key: value
    }))
  }
}

export { updateSetCountKeyWorkoutExerciseAction }
